import { render, staticRenderFns } from "./CreateTop.vue?vue&type=template&id=64c34564&"
import script from "./CreateTop.vue?vue&type=script&lang=js&"
export * from "./CreateTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports